import React from 'react';
import {OverlayTrigger, Tooltip} from "react-bootstrap";

export function isCompanyApiKeyActive(row) {
  const notExpired = !row.expiresAt || new Date(row.expiresAt).getTime() > Date.now();
  return !!row.isActive && !row.isRevoked && notExpired;
}

function ActionsColumnFormatter({row, onRevoke, onReactivate}) {
  const isActive = isCompanyApiKeyActive(row);
  const title = isActive ? "Revoke" : "Reactivate";
  return (
    <OverlayTrigger
      key={'top'}
      placement={'top'}
      overlay={
        <Tooltip>
          {title}
        </Tooltip>
      }
    >
      <a
        title={title}
        className={`btn btn-icon btn-sm ${isActive ? "btn-danger" : "btn-success"}`}
        onClick={() => isActive ? onRevoke(row) : onReactivate(row)}
      >
        <i className={`fa ${isActive ? "fa-ban" : "fa-undo"}`}/>
      </a>
    </OverlayTrigger>
  );
}

ActionsColumnFormatter.propTypes = {};
ActionsColumnFormatter.defaultProps = {};

export default ActionsColumnFormatter;
